import AirPlane from 'components/svg/airtPlane';
import CloseCircle from 'components/svg/closeCircle';
import React from 'react';
import styles from './resend.module.scss';

interface iProps {
  className?: string;
  isResending: boolean;
  isRevoking: boolean;
  resend: () => void;
  revoke: () => void;
}

function Resend(props: iProps): JSX.Element {
  const {
    className,
    isResending = false,
    isRevoking = false,
    resend,
    revoke,
  } = props;

  return (
    <div className={`${className} ${styles.resendContainer}`}>
      <button
        type="submit"
        className={styles.resendBtn}
        onClick={resend}
        disabled={isResending}
      >
        <AirPlane className={styles.resendIcon} />
        {isResending ? 'Resending' : 'Resend'}
      </button>
      <button
        type="submit"
        className={styles.resendBtn}
        onClick={revoke}
        disabled={isRevoking}
      >
        <CloseCircle className={styles.resendIcon} />{' '}
        {isRevoking ? 'Revoking' : 'Revoke'}
      </button>
    </div>
  );
}

Resend.defaultProps = {
  className: '',
};

export default Resend;
